import { getScopedItem, STORAGE_KEYS } from "../components/common/Helper";
import APIConstants from "./APIConstants";
import APIService, { setAuthToken } from "./APIService";
import DebugService from "./DebugService";

/**
 * @description Subscription Api Service
 */
const SubscriptionApiService = {

  /**
   * Get Master Plan List
   * @param {*} platform 
   * @returns 
   */
  getPlanList: async (platform) => {
    try {
      let url = APIConstants.ENDPOINT_SUBSCRIPTION_PLANS
      if (platform) {
        url += `?platformEnum=${platform}`
      }
      return await APIService.get(url)
    } catch (err) {
      DebugService.error('Subscription Api Service: Caught error while fetching plans', err, platform)
    }
  },

  /**
   * Create Subscription
   * @param {*} data 
   * @returns 
   */
  createSubscription: async (data) => {
    try {
      return await APIService.post(APIConstants.ENDPOINT_CREATE_SUBSCRIPTION, data)
    } catch (err) {
      DebugService.error('Subscription Api Service: Caught error while creating subscription', err, data)
    }
  },
  
  /**
   * @description Buy Subscription
   * @param {*} data 
   * @returns 
   */
  buySubscription: async (data) => {
    try {
      return await APIService.post(APIConstants.ENDPOINT_BUY_NEW_SUBSCRIPTION, data)
    } catch (err) {
      DebugService.error('Subscription Api Service: Caught error while buying new subscription', err, data)
    }
  },

  /**
   * @description Activate existing subscription
   * @param {*} data 
   * @returns 
   */
  activateSubscription: async (data) => {
    try {
      return await APIService.post(APIConstants.ENDPOINT_ACTIVATE_SUBSCRIPTION, data)
    } catch (err) {
      DebugService.error('Subscription Api Service: Caught error while activating subscription', err, data)
    }
  },

  /**
   * @description Cancel Subscription
   * @param {*} data 
   * @returns 
   */
  cancelSubscription: async (data) => {
    try {
      return await APIService.post(APIConstants.ENDPOINT_CANCEL_SUBSCRIPTION, data)
    } catch (err) {
      DebugService.error('Subscription Api Service: Caught error while cancelling subscription', err, data)
    }
  },
  
  /**
   * Verify Subscription
   * @param {*} data 
   * @returns 
   */
  verifySubscription: async (data) => {
    try {
      return await APIService.post(APIConstants.ENDPOINT_VERIFY_SUBSCRIPTION, data)
    } catch (err) {
      DebugService.error('Subscription Api Service: Caught error while verifying subscription', err, data)
    }
  },

  /**
   * Get Purchased Plan (Subscription) List
   * @param {*} data 
   * @returns 
   */
  getPurchasedPlanList: async (data) => {
    try {

      if(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN)) {
        setAuthToken(getScopedItem(STORAGE_KEYS.LOCAL_LOGIN_TOKEN))
      }

      const userId = data['userId'] ?? 0
      let url = `${APIConstants.ENDPOINT_SUBSCRIPTION}/${userId}`

      if (data['selectedAccount']) {
          url += `?accountId=${data['selectedAccount']}`
        }

      return await APIService.get(url)
    } catch (err) {
      DebugService.error('Subscription Api Service: Caught error while fetching purchased plans', err, data)
    }
  },
  
  // buyPlan: async (data) => {
  //   try {
  //     return await APIService.post(APIConstants.ENDPOINT_BUY_SUBSCRIPTION_PLAN, data)
  //   } catch (err) {
  //     DebugService.error('Subscription Api Service: Caught error while buying subscription plan', err, data)
  //   }
  // },

};

export default SubscriptionApiService;
